var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAngleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23659 0.334735C9.6829 0.781049 9.6829 1.50467 9.23659 1.95098L3.18757 8L9.23659 14.049C9.6829 14.4953 9.6829 15.219 9.23659 15.6653C8.79028 16.1116 8.06666 16.1116 7.62035 15.6653L0.763202 8.80812C0.316888 8.36181 0.316888 7.63819 0.763202 7.19188L7.62035 0.334735C8.06666 -0.111578 8.79028 -0.111578 9.23659 0.334735Z",
    fill: "#98A9BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAngleIcon);
export default __webpack_public_path__ + "static/media/leftAngleIcon.f73bad289592be0d49550696af987047.svg";
export { ForwardRef as ReactComponent };